module.exports = __webpack_public_path__ + "static/media/mobile-svgrepo-com.8398c182.svg";